import { QuotingStatus } from '../status/quoting/Quoting';

export const QuotingSidePanel = QuotingStatus;
